import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/fr';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Button } from '@material-ui/core';
import './TabStyles.css';
import { useDispatch, useSelector } from "react-redux";
import { getAllInvestigationActionsEnum } from "../../../../store/action/investigationAction";
import { makeStyles } from "@material-ui/core/styles";
import {getUserById} from "../../../../store/action/user";

const localizer = momentLocalizer(moment);

const useStyles = makeStyles(() => ({
    annulerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(229, 234, 238, 1)',
        color: 'rgba(128, 128, 143, 1)',
        marginRight: '20px'
    },
    validerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(86, 157, 210, 1)',
        color: 'rgba(255, 255, 255, 1)',
        marginRight: '40px'
    }
}));

const CalendrierTab = ({ handlePrevious, handleNext, formData }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const investigationActions = useSelector((state) => state.investigationActionReducer);
    const [user, setUser] = useState(null);
    const assigneeId = formData.assigne;

    useEffect(() => {
        dispatch(getAllInvestigationActionsEnum());

        const fetchUser = async () => {
            if (assigneeId) {
                try {
                    const userData = await getUserById(assigneeId);
                    setUser(userData);

                } catch (error) {
                    console.error('Failed to fetch user:', error.message);
                }
            }
        };

        fetchUser();
    }, [dispatch, assigneeId]);

    const [events, setEvents] = useState([]);

    useEffect(() => {
        if (formData && formData.tasks && user) {
            const tasks = formData.tasks
                .filter(task => task.title && task.plannedDate)
                .map(task => {
                    const key = task.title;
                    const action = investigationActions.investigationActionsEnum.find(action => action.key === key);
                    const actionDetails = action ? action : { actionName: 'Non défini', description: 'Aucune description' };

                    return {
                        title: actionDetails.actionName,
                        start: new Date(task.plannedDate),
                        end: new Date(new Date(task.plannedDate).getTime() + 60 * 60 * 1000),
                        assignedTo: user.firstName || 'Non attribué',
                        priority: task.priority === 'Low' ? 'Faible' :
                            task.priority === 'Medium' ? 'Moyenne' :
                                task.priority === 'High' ? 'Élevée' : 'Non défini',
                        description: actionDetails.description
                    };
                });
            setEvents(tasks);
        }
    }, [formData, investigationActions.investigationActionsEnum, user]);

    const [selectedEvent, setSelectedEvent] = useState(null);

    const handleSelectEvent = (event) => {
        setSelectedEvent(event);
    };

    const calendarMessages = {
        allDay: 'Toute la journée',
        previous: 'Précédent',
        next: 'Suivant',
        today: 'Aujourd\'hui',
        month: 'Mois',
        week: 'Semaine',
        day: 'Jour',
        agenda: 'Agenda',
        date: 'Date',
        time: 'Heure',
        event: 'Événement',
        events: 'Événements',
    };

    return (
        <div className="container">
            <div className="calendar-container">
                <Calendar
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 500, width: '60%' }}
                    messages={calendarMessages}
                    onSelectEvent={handleSelectEvent}
                />
                {selectedEvent ? (
                    <div className="event-details">
                        <h3>Détails de l'événement</h3>
                        <p><strong>Titre:</strong> {selectedEvent.title}</p>
                        <p><strong>Description:</strong> {selectedEvent.description}</p>
                        <p><strong>Date:</strong> {moment(selectedEvent.start).format('YYYY-MM-DD')}</p>
                        <p><strong>Assigné à:</strong> {selectedEvent.assignedTo}</p>
                        <p><strong>Priorité:</strong> {selectedEvent.priority}</p>
                        <Button variant="contained" onClick={() => setSelectedEvent(null)} style={styles.cancelButton}>
                            Annuler
                        </Button>
                    </div>
                ) : (
                    <div className="no-event-selected">
                        <h3>Aucun événement sélectionné</h3>
                        <p>Il faut sélectionner un événement de calendrier pour voir ses détails.</p>
                    </div>
                )}
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <div className={classes.buttonContainer}>
                    <button className={classes.annulerStyle} onClick={handlePrevious}>Précédent</button>
                    <button className={classes.validerStyle} onClick={handleNext}>Suivant</button>
                </div>
            </div>
        </div>
    );
};

const styles = {
    cancelButton: {
        width: '149px',
        height: '36px',
        borderRadius: '5px',
        color: 'white',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(210, 86, 86, 1)',
        marginTop: '10px',
        marginLeft: 'auto'
    }
};

export default CalendrierTab;
